// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import NewCaledonia from '../_raw/flag/icon_flag_new_caledonia.png';

export default () => <img src={NewCaledonia} alt="NewCaledonia" />;
